<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/components/org/ImageUploader'
import GameTeamSuitSelector from '@/components/org/GameTeamSuitSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-team-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'game-team-suit-selector': GameTeamSuitSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            team: {
                id: null,
                matchGroupId: null,
                name: null,
                logoUrl: null,
                homeTeamSuit: null,
                awayTeamSuit: null,
            },
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.team.name) {
                    Toast(this.locale['team-name-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-team'],
                message: this.locale['delete-team-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete',
                    data: {
                        id: this.team.id,
                        matchGroupId: this.team.matchGroupId
                    }
                })
            }).catch(() => {
                // on cancel
            })
        },
        onLogoUploaderDataChange(data) {
            console.log('onLogoUploaderDataChange', this.isEdit, data)
            this.team.logoUrl = data
        },
        onHomeTeamSuitDataChange(data) {
            console.log('onHomeTeamSuitDataChange', data)
            this.team.homeTeamSuit = data.value
        },
        onAwayTeamSuitDataChange(data) {
            console.log('onAwayTeamSuitDataChange', data)
            this.team.awayTeamSuit = data.value
        },
        onTeamNameAutoFocus() {
            return !this.isEdit
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.team.name) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.team
                })
            }
        }
    },
}
</script>

<template>
    <div class="team-edit">
        <van-form>
            <van-field 
                name="team-name" 
                v-model="team.name" 
                :label="locale['team-name-label']" 
                :placeholder="locale['team-name-placeholder']"
                :autofocus="onTeamNameAutoFocus"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="50" 
            />
            <image-uploader
                :label="locale['team-logo-label']"
                :description="locale['team-logo-placeholder']"
                :oversizeMax="5000*1024"
                :oversizeHint="locale['upload-image-oversize']"
                :imageUrl="adjustImageSize(this.team.logoUrl, 400, 400)"
                @change-data="onLogoUploaderDataChange"
            />
            <div class="t-outer-margin">
                <van-row>
                    <van-col span="12">
                        <game-team-suit-selector
                            :label="locale['game-home-team-suit-label']"
                            :placeholder="locale['optional']"
                            :value="team.homeTeamSuit"
                            :clearable="true"
                            @change-data="onHomeTeamSuitDataChange"
                        />
                    </van-col>
                    <van-col span="12">
                        <game-team-suit-selector
                            :label="locale['game-away-team-suit-label']"
                            :placeholder="locale['optional']"
                            :value="team.awayTeamSuit"
                            :clearable="true"
                            @change-data="onAwayTeamSuitDataChange"
                        />
                    </van-col>
                </van-row>
            </div>
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>